module.exports = __webpack_public_path__ + "img/9badb83.png";